import React, {useState, useEffect, useRef} from "react";
import { formatLocalString } from "../../utils/validation";
import PopupCoupon from "../../components/Popup/CouponSelectPopup";
import PopupLoginError from "../Popup/LoginError";
import { useLanguage } from "../../hooks/useLanguage";

function OrderPayment({ orderSummary, onUpdateParams, orderType, orderStatus, requestParams, onReset }){
  const { t } = useLanguage();
  // const [cashOpen, setCashOpen] = useState(false); //예치금 셀렉박스
  // const [chooseItem, setChooseItem] = useState('휴대폰 번호'); //예치금 셀렉박스
  const selectRef = useRef(null);
  const [rawPointValue, setRawPointValue] = useState('');
  const [isMaxPointChecked, setIsMaxPointChecked] = useState(false);
  const[isPopupCoupon, setPopupCoupon] = useState(false); // 쿠폰조회 팝업
  const totalPointRef = useRef(orderSummary?.totalInfo?.total_point || 0);
  const prevPointRef = useRef(''); // 이전 포인트 값 저장용 ref
  const [isPopupOpen, setIsPopupOpen] = useState(false); // 팝업
  // 보험 선택 상태 추가
  const [selectedInsurance, setSelectedInsurance] = useState('');
  
  // 라디오 버튼 부분 수정
  // const receiptTypes = [
  //   { label: t('for_personal_tax'), value: 'P' },
  //   { label: t('for_business_expense'), value: 'C' },
  //   { label: t('no_receipt'), value: 'N' }
  // ];

  // const [receiptType, setReceiptType] = useState('P'); // 기본값 '미발행'
  // const [receiptNumber, setReceiptNumber] = useState('');
  
  // 예치금 관련 state 추가
  const [rawBalanceValue, setRawBalanceValue] = useState('');
  const [isMaxBalanceChecked, setIsMaxBalanceChecked] = useState(false);
  const prevBalanceRef = useRef('');
  
  // 최대 할인 적용 체크박스 상태 추가
  const [isMaxDiscountChecked, setIsMaxDiscountChecked] = useState(false);
  
  const pointInputTimeout = useRef(null);
  
  useEffect(() => {
    totalPointRef.current = orderSummary?.totalInfo?.total_point || 0;
  }, [orderSummary]);

  // onReset이 변경될 때마다 모든 입력값 초기화
  useEffect(() => {
    if (onReset !== undefined) {
      // 모든 입력값 초기화
      setRawPointValue('');
      setIsMaxPointChecked(false);
      setRawBalanceValue('');
      setIsMaxBalanceChecked(false);
      setIsMaxDiscountChecked(false);
      setSelectedInsurance('');
      
      // API에 초기화된 값 전달
      onUpdateParams({
        point: '',
        allPointUse: 'N',
        balance: '',
        allBalanceUse: 'N',
        maxCouponUse: 'N',
        download_seq: '',
        insurance_seq: ''
      });
      
      // 이전 값 초기화
      prevPointRef.current = '';
      prevBalanceRef.current = '';
    }
  }, [onReset, onUpdateParams]);

  // useEffect 부분 수정
  useEffect(() => {
    // requestParams 값이 변경될 때마다 체크박스 상태 업데이트
    if (requestParams) {
      // 외부에서 강제로 초기화된 경우만 처리
      if (requestParams.forceReset === true) {
        // maxCouponUse가 N이면 최대 할인 적용 체크박스 해제
        if (requestParams.maxCouponUse === 'N') {
          setIsMaxDiscountChecked(false);
        }
        
        // allPointUse가 N이면 최대 포인트 적용 체크박스 해제
        if (requestParams.allPointUse === 'N') {
          setIsMaxPointChecked(false);
          setRawPointValue('');
        }
        
        // allBalanceUse가 N이면 최대 예치금 적용 체크박스 해제
        if (requestParams.allBalanceUse === 'N') {
          setIsMaxBalanceChecked(false);
          setRawBalanceValue('');
        }
      }
    }
  }, [requestParams]);

  // 예치금 셀렉박스
  // const handleToggle = () => {
  //   setCashOpen(!cashOpen);
  // };

  // const handleSelectItem = (item) => {
  //   setChooseItem(item);
  //   setCashOpen(false);
    
  //   // 번호 초기화 및 상위 컴포넌트에 전달
  //   setReceiptNumber('');
  //   onUpdateParams({
  //     deposit_cash_receipt: receiptType,
  //     deposit_cash_num: ''
  //   });
  // }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        // setCashOpen(false); // 외부 클릭 시 드롭다운 닫기
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  // 포인트 입력 핸들러 - 숫자만 받기
  const handlePointInput = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, '');
    setRawPointValue(raw);
  
    // 사용자가 직접 입력하면 체크 해제
    if (isMaxPointChecked) {
      setIsMaxPointChecked(false);
    }
    
    // 입력 즉시 API 호출을 하지 않고, debounce 처리
    clearTimeout(pointInputTimeout.current);
    pointInputTimeout.current = setTimeout(() => {
      if (raw) {
        const numeric = parseInt(raw, 10);
        const totalPoint = totalPointRef.current;
        const capped = Math.min(numeric, totalPoint);
        const cappedString = capped.toString();
        
        if (prevPointRef.current !== cappedString) {
          onUpdateParams({
            point: cappedString,
            allPointUse: 'N',
            forceReset: false
          });
          prevPointRef.current = cappedString;
        }
      } else {
        if (prevPointRef.current !== '') {
          onUpdateParams({
            point: '',
            allPointUse: 'N',
            forceReset: false
          });
          prevPointRef.current = '';
        }
      }
    }, 300);
  };

  const validatePointInput = () => {
    if (!rawPointValue) return;
  
    const numeric = parseInt(rawPointValue, 10);
    const useAblePoint = orderSummary?.totalInfo?.useAbleOrderPoint || 0;
  
    if (isNaN(numeric)) return;
  
    if (numeric % 1000 !== 0) {
      setIsPopupOpen(t('point_usage_unit'));
      setRawPointValue('');
      return;
    }
  
    if (numeric > useAblePoint) {
      // 이 팝업에 값이 천원단위로 떨어져야함 . 2458원이면 2000원으로 떨어져야하고, 2950원이면 2000원으로 떨어지고, 3450원이면 3000원으로 떨어져야함.
      setIsPopupOpen(`사용 가능한 최대 포인트는 ${formatLocalString(useAblePoint)}P 입니다.`);
      setRawPointValue('');
    }
  };

  // 최대 포인트 적용 체크박스 핸들러
  const handleMaxPointCheck = (e) => {
    const isChecked = e.target.checked;
    setIsMaxPointChecked(isChecked);
    
    if (isChecked) {
        // 예치금 관련 상태 초기화
        setIsMaxBalanceChecked(false);
        setRawBalanceValue('');
        
        // 최대 포인트 적용
        const useAblePoint = orderSummary?.totalInfo?.useAbleOrderPoint || 0;
        const roundedPoint = Math.floor(useAblePoint / 1000) * 1000;
        const roundedPointString = roundedPoint.toString();
        
        setRawPointValue(roundedPointString);
        
        // 예치금 초기화와 포인트 적용을 동시에 API에 전달
        onUpdateParams({
            point: roundedPointString,
            allPointUse: 'Y',
            balance: '',
            allBalanceUse: 'N'
        });
        prevPointRef.current = roundedPointString;
        prevBalanceRef.current = '';
    } else {
        setRawPointValue('');
        
        if (prevPointRef.current !== '') {
            onUpdateParams({
                point: '',
                allPointUse: 'N'
            });
            prevPointRef.current = '';
        }
    }
  };

  // 0이 아닌 값을 선택하는 함수
  const getNonZeroValue = (value1, value2) => {
    const val1 = Number(value1) || 0;
    const val2 = Number(value2) || 0;
    
    if (val1 > 0) return val1;
    if (val2 > 0) return val2;
    return 0;
  };

  // 쿠폰조회 핸들러 수정
  const handleCouponPopup = () => {
    // 포인트와 예치금 초기화
    setRawPointValue('');
    setIsMaxPointChecked(false);
    setRawBalanceValue('');
    setIsMaxBalanceChecked(false);
    setIsMaxDiscountChecked(false); // 최대 할인 적용 체크 해제
    
    // API에 초기화된 값 전달
    onUpdateParams({
      point: '',
      allPointUse: 'N',
      balance: '',
      allBalanceUse: 'N',
      maxCouponUse: 'N'  // maxCouponUse를 'N'으로 설정
    });
    
    // 이전 값 초기화
    prevPointRef.current = '';
    prevBalanceRef.current = '';
    
    setPopupCoupon(true);
  };

  // 쿠폰 확인 핸들러 수정
  const handleCouponConfirm = (downloadSeq) => {
    // 포인트와 예치금 초기화
    setRawPointValue('');
    setIsMaxPointChecked(false);
    setRawBalanceValue('');
    setIsMaxBalanceChecked(false);
    setIsMaxDiscountChecked(false); // 최대 할인 적용 체크 해제
    
    onUpdateParams({
      download_seq: downloadSeq,
      point: '',
      allPointUse: 'N',
      balance: '',
      allBalanceUse: 'N',
      maxCouponUse: 'N'  // maxCouponUse를 'N'으로 설정
    });
    
    // 이전 값 초기화
    prevPointRef.current = '';
    prevBalanceRef.current = '';
  };

  // 보험 선택 핸들러
  const handleInsuranceSelect = (insuranceSeq) => {
    setSelectedInsurance(insuranceSeq);
    onUpdateParams({
      insurance_seq: insuranceSeq,
    });
  };

  // receiptType 변경 시 호출
  // const handleReceiptTypeChange = (e) => {
  //   const newType = e.target.value;
  //   setReceiptType(newType);
    
  //   // 현금영수증 타입이 변경될 때마다 상위 컴포넌트에 전달
  //   onUpdateParams({
  //     deposit_cash_receipt: newType,
  //     deposit_cash_num: newType === 'N' ? '' : receiptNumber // N인 경우 번호 초기화
  //   });
  // };

  // receiptNumber 변경 시 호출
  // const handleReceiptNumberChange = (e) => {
  //   const newNumber = e.target.value;
  //   setReceiptNumber(newNumber);
    
  //   // 번호가 변경될 때마다 상위 컴포넌트에 전달
  //   onUpdateParams({
  //     deposit_cash_receipt: receiptType,
  //     deposit_cash_num: newNumber
  //   });
  // };

  // 예치금 입력 핸들러
  const handleBalanceInput = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, '');
    setRawBalanceValue(raw);

    // 사용자가 직접 입력하면 체크 해제
    if (isMaxBalanceChecked) {
      setIsMaxBalanceChecked(false);
    }
  };

  // 예치금 유효성 검사 함수 추가
  const validateBalanceInput = () => {
    if (!rawBalanceValue) return;

    const numeric = parseInt(rawBalanceValue, 10);
    const useAbleBalance = orderSummary?.totalInfo?.useAbleBalance || 0;

    if (isNaN(numeric)) return;

    // if (numeric % 1000 !== 0) {
    //   setIsPopupOpen('예치금은 1,000원 단위로만 입력 가능합니다.');
    //   setRawBalanceValue('');
    //   return;
    // }

    if (numeric > useAbleBalance) {
      setIsPopupOpen(`사용 가능한 최대 예치금은 ${formatLocalString(useAbleBalance)}원 입니다.`);
      setRawBalanceValue('');
    }
  };

  // 최대 예치금 적용 체크박스 핸들러
  const handleMaxBalanceCheck = (e) => {
    const isChecked = e.target.checked;
    setIsMaxBalanceChecked(isChecked);
    
    if (isChecked) {
      const useAbleBalance = orderSummary?.totalInfo?.useAbleBalance || 0;
      const roundedBalance = useAbleBalance; // Math.floor(useAbleBalance / 1000) * 1000 : 0;
      const roundedBalanceString = roundedBalance.toString();
      
      setRawBalanceValue(roundedBalanceString);
      
      if (prevBalanceRef.current !== roundedBalanceString) {
        onUpdateParams({
          balance: roundedBalanceString,
          allBalanceUse: 'Y'
        });
        prevBalanceRef.current = roundedBalanceString;
      }
    } else {
      setRawBalanceValue('');
      
      if (prevBalanceRef.current !== '') {
        onUpdateParams({
          balance: '',
          allBalanceUse: 'N'
        });
        prevBalanceRef.current = '';
      }
    }
  };

  // 최대 할인 적용 체크박스 핸들러 수정
  const handleMaxDiscountCheck = (e) => {
    const isChecked = e.target.checked;
    setIsMaxDiscountChecked(isChecked);
    
    if (isChecked) {
      // 포인트와 예치금 초기화
      setRawPointValue('');
      setIsMaxPointChecked(false);
      setRawBalanceValue('');
      setIsMaxBalanceChecked(false);
      
      onUpdateParams({
        point: '',
        allPointUse: 'N',
        balance: '',
        allBalanceUse: 'N',
        maxCouponUse: 'Y',  // 최대 할인 적용 시 Y로 설정
        download_seq: '',    // 쿠폰 초기화
        coupon_seq: ''      // 쿠폰 초기화
      });
      
      // 이전 값 초기화
      prevPointRef.current = '';
      prevBalanceRef.current = '';

      setPopupCoupon(false);
    } else {
      onUpdateParams({
        maxCouponUse: 'N',  // 체크 해제 시 N으로 설정
        download_seq: '',    // 쿠폰 초기화
      });
    }
  };

  // 예치금 입력값 처리 및 API 호출
  useEffect(() => {
    if (!rawBalanceValue) {
      if (prevBalanceRef.current !== '') {
        onUpdateParams({
          balance: '',
          allBalanceUse: 'N',
        });
        prevBalanceRef.current = '';
      }
      return;
    }

    const numeric = parseInt(rawBalanceValue, 10);
    const useAbleBalance = orderSummary?.totalInfo?.useAbleBalance || 0;

    if (isNaN(numeric)) return;

    const capped = Math.min(numeric, useAbleBalance);
    const cappedString = capped.toString();

    if (prevBalanceRef.current !== cappedString) {
      onUpdateParams({
        balance: cappedString,
        allBalanceUse: 'N',
      });
      prevBalanceRef.current = cappedString;
    }
  }, [rawBalanceValue, onUpdateParams, orderSummary]);

  return(
    <div>
      {/* 보험, 보증금 > (주문)판매 / (마이페이지)연장신청페이지에서 미표출 */}
      <ul className="default_info_table payment">
        <li className="info_item total_order_price">
          <div className="label pd_16">
            <span>{t('total_product_amount')}</span>
          </div>
          <div className="form_info ">
            <span className="info_detail order_amount pd_16 txt_right">₩{formatLocalString(orderSummary?.totalInfo?.sumRentalPrice || 0)}</span>
          </div>
        </li>

        {/* 배송비 영역 노출 > 택배, 판매 */}
        {/* orderType이 visite일 때 보이지 않게 */}
        {orderStatus !== 'extension' && orderType !== 'visit' && (
        <li className="info_item discount_benefit">
          <div className="label">
            <span>{t('delivery_fee')}</span>
          </div>
          <div className="form_info">
            <span className="info_detail order_amount">₩{formatLocalString(orderSummary?.totalInfo?.delivery_price || 0)}</span>

            {/* 디폴트 : additional_amount (그레이) /   - : red 클래스명 추가해주세요  */}
            <p className="info_detail additional_amount red">
              <span>+</span>₩{formatLocalString(orderSummary?.totalInfo?.delivery_price || 0)}
            </p>
          </div>
        </li>
        )}

      {orderSummary?.totalInfo?.group_mtype_sale_name && (
        <li className="info_item discount_benefit">
          <div className="label">
            <span>{t('member_discount_benefit')}</span>
          </div>
          <div className="form_info">
            <span className="info_detail order_amount">{orderSummary?.totalInfo?.group_mtype_sale_name}</span>
            {/* 디폴트 : additional_amount (그레이) /   - : red 클래스명 추가해주세요  */}
            <p className="info_detail additional_amount red">
              <span>-</span>₩{formatLocalString(
                getNonZeroValue(
                  orderSummary?.totalInfo?.sumGroupSale,
                  orderSummary?.totalInfo?.sumMtypeSale
                )
              )}
            </p>
          </div>
        </li>
        )}

        {/* first_payment_sale_name 에 값이 없으면 미노출 */}
        {/* 추가 할인 */}
        {orderSummary?.totalInfo?.first_payment_sale_name && (
        <li className="info_item extra_discount">
          <div className="label">
            <span>{t('additional_discount_txt')}</span>
          </div>
          <div className="form_info">
            <span className="info_detail order_amount">{t('first_purchase_discount')} {orderSummary?.totalInfo?.first_payment_sale_name}</span>
            {/* 디폴트 : additional_amount (그레이) /   - : red 클래스명 추가해주세요  */}
            <p className="info_detail additional_amount red">
              <span>-</span>₩{formatLocalString(orderSummary?.totalInfo?.first_payment_sale || 0)}
            </p>
            </div>
          </li>
        )}

        <li className="info_item discount_coupon">
          <div className="label">
            <span>{t('discount_coupon')}</span>
          </div>
          <div className="form_info">
            <div className="payment_form info_detail">
              <div className="mx_558 flex-center">
                <div className="flex-center-2">
                  <div className="default_input comb_input">
                    <p className="placeholder form_input w-100">
                        {formatLocalString(orderSummary?.totalInfo?.sumCouponUse || 0)}
                    </p>
                    <i className="comb_btn-right">₩</i>
                  </div>
                  <button 
                    type="button"
                    className="default_btn sm gray" 
                    onClick={handleCouponPopup}
                  >
                    {t('check_coupon')}
                  </button>
                </div>
                <div className="default_chk_box">
                  <input 
                    type="checkbox" 
                    id="applyDiscount"
                    checked={isMaxDiscountChecked}
                    onChange={handleMaxDiscountCheck}
                  />
                  <label htmlFor="applyDiscount">
                    <span>{t('apply_max_discount')}</span>
                  </label>
                </div>
              </div>
            </div>
            {/* 디폴트 : additional_amount (그레이) /   - : red 클래스명 추가해주세요  */}
            <p className="info_detail additional_amount red">
              <span>-</span>₩{formatLocalString(orderSummary?.totalInfo?.sumCouponUse || 0)}
            </p>
          </div>
        </li>

        <li className="info_item point">
          <div className="label">
            <span>{t('point')}</span>
          </div>
          <div className="form_info">
            <div className="payment_form info_detail">
              <div className="mx_558 flex-center">
                <div className="flex-center gap_16">
                  <div className="default_input comb_input">
                    <input 
                      type="text" 
                      value={rawPointValue ? formatLocalString(parseInt(rawPointValue, 10)) : ''}
                      onChange={handlePointInput}
                      onBlur={validatePointInput}
                      placeholder="0"
                      inputMode="numeric"
                    />
                    <i className="comb_btn-right">P</i>
                  </div>
                  <div className="rest_price">
                    <span className="g-80">{t('balance')}</span>
                    {formatLocalString(orderSummary?.totalInfo?.total_point || 0)}
                    <i className="won">P</i>
                  </div>
                </div>
                <div className="default_chk_box">
                  <input 
                    type="checkbox" 
                    id="allPoint"
                    checked={isMaxPointChecked}
                    onChange={handleMaxPointCheck}
                  />
                  <label htmlFor="allPoint">
                    <span>{t('apply_max_point')}</span>
                  </label>
                </div>
              </div>
              <div className="point_info">
                <ul className="dash_list guide_text flex-2 column g-80">
                  <li>
                    -<p>{t('point_usage_unit_txt')}
                        <span className="red"> {orderSummary?.pointSetting?.payLimitPer}%</span>
                        {t('point_usage_unit2')}
                      </p>
                  </li>   
                  <li>
                    -<p>
                      {t('point_usage_unit3')}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* 디폴트 : additional_amount (그레이) /   - : red 클래스명 추가해주세요  */}
            <p className="info_detail additional_amount red">
              <span>-</span>₩{formatLocalString(orderSummary?.totalInfo?.sumPointUse || 0)}
            </p>
          </div>
        </li>

        <li className="info_item deposit_price">
          <div className="label">
            <span>{t('deposit_cash_receipt')}</span>
          </div>
          <div className="deposit_con">
            <div className="form_info">
              <div className="payment_form info_detail">
                <div className="mx_558 flex-center">
                  <div className="flex-center gap_16">
                    <div className="default_input comb_input">
                      <input 
                        type="text"
                        value={rawBalanceValue ? formatLocalString(parseInt(rawBalanceValue, 10)) : ''}
                        onChange={handleBalanceInput}
                        onBlur={validateBalanceInput}
                        placeholder="0" 
                      />
                      <i className="comb_btn-right">₩</i>
                    </div>
                    <div className="rest_price">
                      <span className="g-80">{t('balance')}</span>
                      {formatLocalString(orderSummary?.totalInfo?.total_balance || 0)}<i className="won">원</i>
                    </div>
                  </div>
                  <div className="default_chk_box">
                    <input 
                      type="checkbox"
                      id="allDeposit"
                      checked={isMaxBalanceChecked}
                      onChange={handleMaxBalanceCheck}
                    />
                    <label htmlFor="allDeposit">
                      <span>{t('apply_max_deposit')}</span>
                    </label>
                  </div>
                </div>
                <div className="dash_list flex-2 column">
                  {/* <span className="guide_text_1 g-80">
                    {t('deposit_cash_receipt_txt')}
                  </span> */}
                  <span className="guide_text_1 g-80">
                    {t('deposit_cash_receipt2')}
                  </span>
                </div>
              </div>
              {/* 디폴트 : additional_amount (그레이) /   - : red 클래스명 추가해주세요  */}
              <p className="info_detail additional_amount red">
                <span>-</span>₩{formatLocalString(orderSummary?.totalInfo?.balance || 0)}
              </p>
            </div>
            {/* <div className="form_info w-100 cash_receipts">
              <div className="info_detail">
                <span className="label_re">{t('apply_cash_receipt')}</span>
                <div className="default_radio radio_list">
                  {receiptTypes.map(({ label, value }) => (
                    <div key={value}>
                      <input
                        type="radio"
                        name="receipt_type"
                        id={`receipt_type_${value}`}
                        value={value}
                        checked={receiptType === value}
                        onChange={handleReceiptTypeChange}
                      />
                      <label htmlFor={`receipt_type_${value}`}>{label}</label>
                    </div>
                  ))}
                </div>
                
                {receiptType !== 'N' && (
                  <div className="case_none">
                    <div className="default_input flex-center-8 receipt_form">
                      <div 
                        ref={selectRef}
                        className={`default_select border ${cashOpen ? 'open' : ''}`}
                        onClick={handleToggle}
                      >
                        <button 
                          type="button"
                          className="select_btn gray_icon" 
                          >
                          <span className="ellipsis_clamp">{chooseItem}</span>
                        </button>
                        {cashOpen && (
                          <ul className="select_list">
                            <li 
                              className={`ellipsis1 select_item ${chooseItem === '휴대폰 번호' ? 'active' : ''}`}
                              onClick={()=>handleSelectItem('휴대폰 번호')}
                              >{t('phone_number')}</li>
                            <li 
                              className={`ellipsis1 select_item ${chooseItem === '현금 영수증 번호' ? 'active' : ''}`}
                              onClick={()=>handleSelectItem('현금영수증 번호')}
                            >{t('cash_receipt_number')}</li>
                          </ul>
                        )}
                      </div>
                      <input 
                        type="number"
                        value={receiptNumber}
                        onChange={handleReceiptNumberChange}
                      />
                    </div>
                    <span className="dash_list guide_text_1 g-80">
                      {t('information_communication_network_law')}
                    </span>
                  </div>
                )}
              </div>
            </div> */}
          </div>
        </li>


        {(orderType === 'visit' || orderType === 'parcel') && orderStatus !== 'extension' && (
          orderSummary?.insuranceSetting?.use_flag === 'Y' && (
        <li className="info_item insurance">
          <div className="label">
            <span>{t('insurance')}</span>
          </div>
          <div className="insurance_con">
            <div className="form_info w-100">
              <div className="info_detail">
                <div className="default_radio radio_list">
                  <div>
                    <input
                      type="radio"
                      id="insurance_type_none"
                      name="insurance_type"
                      checked={selectedInsurance === ''}
                      onChange={() => handleInsuranceSelect('', 0)}
                    />
                    <label htmlFor="insurance_type_none">{t('unselected')}</label>
                  </div>
                  {orderSummary?.insuranceList?.map((insurance, index) => (
                    <div key={index}>
                      <input
                        type="radio"
                        id={`insurance_type_${insurance.insurance_seq}`}
                        name="insurance_type"
                        checked={selectedInsurance === insurance.insurance_seq}
                        onChange={() => handleInsuranceSelect(
                          insurance.insurance_seq,
                          insurance.insurance_price
                        )}
                      />
                      <label htmlFor={`insurance_type_${insurance.insurance_seq}`}>
                        {insurance.insurance_kind}
                      </label>
                    </div>
                  ))}
                </div>
                <ul className="dash_list guide_text g-80">
                  {orderSummary?.insuranceList?.map((insurance) => (
                    <li key={insurance.insurance_seq}>
                      -<p>
                        <span className="black">{insurance.insurance_kind}: </span>
                        {/* {t('insurance_fee')} */}수리비용보상
                        <span className="red"> {insurance.insurance_repair_per}{orderSummary?.insuranceSetting?.apply_kind === '1' ? '%' : '원'}</span>
                        {/* {orderSummary?.insuranceSetting?.apply_kind === '1' ? t('insurance_fee5') : t('insurance_fee4')} */}
                        , 보험료
                        <span className="black"> ₩{formatLocalString(insurance.insurance_price || 0)}</span>
                        {/* {t('insurance_fee2')} */}

                      </p>
                    </li>
                  ))}
                </ul>
              </div>
              <p className="info_detail additional_amount black">
                <span>+</span>₩{formatLocalString(
                  orderSummary?.totalInfo?.insurance_price || 0
                )}
              </p>
            </div>
          </div>
        </li>
        )
      )}

      {(orderType === 'visit' || orderType === 'parcel') && orderStatus !== 'extension' && (
        orderSummary?.depositSetting?.useFlag === 'Y' && (
        <li className="info_item insurance">
          <div className="label">
            <span>{t('deposit')}</span>
          </div>
          <div className="insurance_con">
            <div className="form_info w-100">
              <div className="info_detail">
                <ul className="flex-2 column guide_text g-80">
                  <li>
                    -<p>
                        {t('insurance_fee6')}
                        <span className="red"> {orderSummary?.depositSetting?.orderRate}%</span>
                        {t('insurance_fee7')}
                      </p>
                  </li>
                  <li>
                    -<p>{t('insurance_fee8')}
                        <span className="black"> ₩{formatLocalString(orderSummary?.depositSetting?.depositMin || 0)}</span>
                        {t('insurance_fee9')}
                        <span className="black"> ₩{formatLocalString(orderSummary?.depositSetting?.depositMax || 0)}</span>
                        {t('insurance_fee10')}
                      </p>
                  </li>   
                  <li>
                    -<p>
                        <span>
                          {t('insurance_fee11')}
                        </span>
                      </p>
                  </li>
                </ul>
              </div>
            { /* [ 보험,  보증금 텍스트 색] 
              디폴트 0원 : additional_amount (그레이)  /  + : black (블랙) 클래스명 추가해주세요  */}  
              <p className="info_detail additional_amount black">
                <span>+</span>₩{formatLocalString(orderSummary?.totalInfo?.deposit_price || 0)}
              </p>
            </div>
          </div>
        </li>
        )
      )}


        <li className="info_item total_pay_price">
          <div className="label">
            <span>{t('total_payment_amount3')}</span>
          </div>
          <div className="form_info">
            <span className="info_detail order_amount">₩{formatLocalString(orderSummary?.totalInfo?.settlePrice || 0)}</span>
            <p className="info_detail additional_amount">
              <span>+</span>₩{formatLocalString(orderSummary?.totalInfo?.settlePrice || 0)}
            </p>
          </div>
        </li>
      </ul>
      <PopupCoupon 
        isPopup={isPopupCoupon} 
        setIsPopup={setPopupCoupon} 
        settlePrice={orderSummary?.totalInfo?.settlePrice || 0}
        onConfirm={handleCouponConfirm}
        orderType={orderType}
      />
      <PopupLoginError isPopup={isPopupOpen} setIsPopup={setIsPopupOpen}/>

    </div>
  )
};

export default OrderPayment;